import type { AnalyticsKpi } from '@/mocks/superAdminAnalytics';

interface KpiCardProps {
  kpi: AnalyticsKpi;
}

function formatValue(value: number, format: AnalyticsKpi['format']): string {
  switch (format) {
    case 'duration': {
      const hours = Math.floor(value / 3600);
      const minutes = Math.floor((value % 3600) / 60);
      return `${hours}h ${minutes}m`;
    }
    case 'storage': {
      if (value >= 1000) return `${(value / 1000).toFixed(1)} TB`;
      return `${value.toFixed(1)} GB`;
    }
    default: {
      if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
      if (value >= 1_000) return `${(value / 1_000).toFixed(1)}K`;
      return value.toLocaleString();
    }
  }
}

export default function KpiCard({ kpi }: KpiCardProps) {
  const isPositive = kpi.changePercent >= 0;
  const absChange = Math.abs(kpi.changePercent);

  return (
    <div className="bg-background-50 border border-background-200 rounded-2xl p-4 flex flex-col justify-between hover:border-background-300 transition-colors">
      <div className="flex items-center justify-between mb-3">
        <span className="text-foreground-400 text-[10px] font-semibold uppercase tracking-wider">{kpi.label}</span>
        <div className="w-8 h-8 rounded-lg bg-background-100 flex items-center justify-center">
          <i className={`${kpi.icon} text-foreground-500 text-sm`}></i>
        </div>
      </div>
      <div>
        <p className="text-foreground-950 font-bold text-xl leading-tight">
          {formatValue(kpi.value, kpi.format)}
        </p>
        <div className="flex items-center gap-1 mt-1">
          <span className={`inline-flex items-center gap-0.5 text-[10px] font-semibold ${isPositive ? 'text-emerald-600' : 'text-red-500'}`}>
            <i className={`${isPositive ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} text-[9px]`}></i>
            {absChange.toFixed(1)}%
          </span>
          <span className="text-foreground-300 text-[9px]">vs anterior</span>
        </div>
      </div>
    </div>
  );
}